import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const Configuration: FC = () => {  
    return (
        <Outlet />
    );
}

export default Configuration